import React from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';
import { ChevronDown } from 'lucide-react';

interface SelectProps {
  value: string;
  onValueChange: (value: string) => void;
  children: React.ReactNode;
  disabled?: boolean;
  placeholder?: string;
  position?: 'default' | 'left';
  contentStyle?: React.CSSProperties;
  onOpenChange?: (open: boolean) => void;
}

interface SelectItemProps {
  value: string;
  children: React.ReactNode;
}

export const Select: React.FC<SelectProps> = ({
  value,
  onValueChange,
  children,
  disabled = false,
  placeholder = "选择...",
  position = 'default',
  contentStyle,
  onOpenChange
}) => {
  const contentClassName = `select-content ${position === 'left' ? 'select-content-left' : ''}`;

  return (
    <SelectPrimitive.Root value={value} onValueChange={onValueChange} disabled={disabled} onOpenChange={onOpenChange}>
      <SelectPrimitive.Trigger className="select-trigger">
        <SelectPrimitive.Value placeholder={placeholder} />
        <SelectPrimitive.Icon>
          <ChevronDown className="select-icon" />
        </SelectPrimitive.Icon>
      </SelectPrimitive.Trigger>
      <SelectPrimitive.Portal>
        <SelectPrimitive.Content className={contentClassName} style={contentStyle}>
          <SelectPrimitive.Viewport>
            {children}
          </SelectPrimitive.Viewport>
        </SelectPrimitive.Content>
      </SelectPrimitive.Portal>
    </SelectPrimitive.Root>
  );
};

export const SelectItem: React.FC<SelectItemProps> = ({ value, children }) => {
  return (
    <SelectPrimitive.Item value={value} className="select-item">
      <SelectPrimitive.ItemText>{children}</SelectPrimitive.ItemText>
    </SelectPrimitive.Item>
  );
};
